import { iSharedCartPayload } from "../../api/sharedCart/sharedCart";

export const sharedDetailsPayload = ({ search, ...snapshot }: iSharedCartPayload): iSharedCartPayload =>
  Array.isArray(snapshot.hotels)
    ? { ...snapshot, hotels: snapshot.hotels.map(({ supplier, rateHotelId, ...hotel }) => hotel) }
    : snapshot;
